import { noTrailingSlashRedirect } from "../middlewares";
function trailing_slash_redirect_default(context) {
  noTrailingSlashRedirect(context);
}
export {
  trailing_slash_redirect_default as default
};
